import Sitemap from "@/components/sitemap";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | Sitemap",
};

const SitemapPage = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <Sitemap />
    </>
  );
};

export default SitemapPage;
